export const POST_MODAL_CONTENT_HEIGHT = "350px";
